<div class="login-information-container">
  <app-data-table
    [config]="loginInfoDataTableConfig"
    [dataSource]="loginInfoTableData"
    [dataSearched]="loginInfoDataSearched">
  </app-data-table>
</div>
